import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle, Heading } from '../../components';
import { images } from '../../constants';
import { FaCheckCircle, FaFileSignature, FaCoins, FaEnvelope, FaPlus } from 'react-icons/fa';
import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';
import './treeInventory.css';

const TreeInventory = () => {
    const { t } = useTranslation();

    const gallery = [
        images.treeInventory3,
        images.treeInventory2,
        images.treeInventory5,
        images.treeInventory4,
        images.treeInventory1,
        images.treeInventory6
    ].filter(Boolean);

    const [photoIndex, setPhotoIndex] = useState(-1);

    const services = t('treeInventory.services', { returnObjects: true }) || [];

    // Funkcja pomocnicza renderująca klikalny kafelek ze zdjęciem
    const renderInlineImage = (imageIndex, className = '') => {
        if (!gallery[imageIndex]) return null;
        return (
            <div className={`tree-inv-photo-card ${className}`}>
                <img src={gallery[imageIndex]} alt={`Dokumentacja ${imageIndex + 1}`} />
                <div className="tree-inv-photo-overlay">
                    <button
                        type="button"
                        onClick={() => setPhotoIndex(imageIndex)}
                        aria-label="Powiększ zdjęcie"
                    >
                        <FaPlus className="plus-icon" />
                    </button>
                </div>
            </div>
        );
    };

    return (
        <div className="tree-inv-wrapper">
            <PageTitle
                title={t('treeInventory.pageTitle')}
                page={t('treeInventory.breadcrumb')}
            />

            <section className="tree-inv-content">
                <div className="tree-inv-container">
                    <Heading
                        title={t('treeInventory.headingTitle')}
                        subTitle={t('treeInventory.headingSubtitle')}
                        sideHeading
                    />

                    {/* BLOK 1: Wstęp + Zdjęcie 1 */}
                    <div className="tree-inv-interleaved-row">
                        <div className="tree-inv-text-col">
                            <p className="tree-inv-lead">
                                {t('treeInventory.lead')}
                            </p>
                            <p className="tree-inv-sublead">
                                {t('treeInventory.secondParagraph')}
                            </p>
                        </div>
                        <div className="tree-inv-image-col">
                            {renderInlineImage(0)}
                        </div>
                    </div>

                    {/* BLOK 2: Mini-baner ze zdjęciami 2 i 3 */}
                    {(gallery[1] || gallery[2]) && (
                        <div className="tree-inv-split-gallery-row">
                            {gallery[1] && renderInlineImage(1)}
                            {gallery[2] && renderInlineImage(2)}
                        </div>
                    )}

                    {/* BLOK 3: Zdjęcie 4 + Zakres usług (układ odwrócony) */}
                    <div className="tree-inv-interleaved-row reverse">
                        <div className="tree-inv-image-col">
                            {renderInlineImage(3, 'tree-inv-photo-tall')}
                        </div>
                        <div className="tree-inv-text-col">
                            <div className="tree-inv-services-box">
                                <h3 className="tree-inv-section-title">
                                    <FaFileSignature className="icon-title" /> {t('treeInventory.scopeTitle')}
                                </h3>
                                <div className="tree-inv-grid">
                                    {Array.isArray(services) && services.map((item, idx) => (
                                        <div key={idx} className="tree-inv-grid-item">
                                            <FaCheckCircle className="check-icon" />
                                            <span>{item}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* BLOK 4: Podejście i Wycena + Zdjęcie 5 obok */}
                    <div className="tree-inv-interleaved-row">
                        <div className="tree-inv-text-col">
                            <div className="tree-inv-cards-column">
                                <div className="tree-inv-info-card">
                                    <div className="card-icon"><FaFileSignature /></div>
                                    <h4>{t('treeInventory.customTitle')}</h4>
                                    <p>{t('treeInventory.customDesc')}</p>
                                </div>
                                <div className="tree-inv-info-card">
                                    <div className="card-icon"><FaCoins /></div>
                                    <h4>{t('treeInventory.pricingTitle')}</h4>
                                    <p>{t('treeInventory.pricingDesc')}</p>
                                </div>
                            </div>
                        </div>
                        <div className="tree-inv-image-col">
                            {renderInlineImage(4)}
                        </div>
                    </div>

                    {/* BLOK 5: Zdjęcie 6 + Kontakt / CTA */}
                    <div className="tree-inv-interleaved-row reverse tree-inv-cta-wrapper-row">
                        <div className="tree-inv-image-col">
                            {renderInlineImage(5)}
                        </div>
                        <div className="tree-inv-text-col">
                            <div className="tree-inv-cta">
                                <h3>{t('treeInventory.ctaTitle')}</h3>
                                <p>{t('treeInventory.ctaDesc')}</p>
                                <a href="mailto:info@dworimielno.com" className="tree-inv-cta-btn">
                                    <FaEnvelope /> {t('treeInventory.contactBtn')}
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Lightbox dla wszystkich zdjęć */}
                    {photoIndex !== -1 && (
                        <Lightbox
                            mainSrc={gallery[photoIndex]}
                            nextSrc={gallery[(photoIndex + 1) % gallery.length]}
                            prevSrc={gallery[(photoIndex + gallery.length - 1) % gallery.length]}
                            onCloseRequest={() => setPhotoIndex(-1)}
                            onMovePrevRequest={() => setPhotoIndex((photoIndex + gallery.length - 1) % gallery.length)}
                            onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % gallery.length)}
                        />
                    )}
                </div>
            </section>
        </div>
    );
};

export default TreeInventory;